import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQItemm from './FAQItemm';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Morachichincholitourpackages() {



    const cardData =
    {
        keyword: 'Morachi Chincholi Tour Package',
        heading: 'Anand Krushi Paryatan Kendra: Morachi Chincholi Tour Package',
        headingDescription: 'Looking for the perfect Morachi Chincholi tour package that blends fun, culture, and rural charm? Anand Krushi Paryatan Kendra, located just 55 km from Pune, offers comprehensive day‑tour and overnight packages ideal for families, school groups, and corporate outings. Spread across 40 acres of verdant farmland, the package includes bullock cart and tractor rides, horse riding, boating, a rain‑dance zone, swimming, and engaging cultural programs like magic shows and puppetry. Guests also enjoy traditional village games, interactive farm demonstrations, bird‑watching (including spotting the famous peacocks), and a taste of authentic Maharashtrian cuisine. With well‑structured itineraries, easy online booking, and a perfect balance of education and entertainment, Anand Krushi Paryatan Kendra is a leading choice for an immersive Morachi Chincholi tour package experience.',

        top: 'Top Activities at Anand Krushi Paryatan Kendra:',
"topPlaces": [
  {
    "title": "Easy Online Booking Facility",
    "description": "Morachi Chincholi Water Park offers a convenient online booking system through its official website. Visitors can pre-book day or night packages for school picnics, family outings, or group tours with confirmed slots and inclusive meals."
  },
  {
    "title": "Water Park with Rain Dance",
    "description": "Enjoy a vibrant rain dance zone equipped with DJ music and safe flooring—ideal for school students and young groups looking to cool off and celebrate with high-energy fun."
  },
  {
    "title": "Clean Swimming Pool Access",
    "description": "The park features a well-maintained swimming pool area with separate sections for kids and adults. Life jackets and supervision ensure safety during splash time fun."
  },
  {
    "title": "Boating and Small Lake Activities",
    "description": "Kids and groups can take short boat rides around the artificial lake within the property. This calm activity adds variety to the high-energy water park experience."
  },
  {
    "title": "Bullock Cart & Tractor Combo Rides",
    "description": "After water fun, students and families can enjoy traditional village transport rides around the premises—perfect for blending rural heritage with a water park vibe."
  },
  {
    "title": "All-Inclusive Day Package",
    "description": "The day package (₹600 for adults, ₹300 for children) includes meals, rides, water park access, and shows—available for online booking to avoid last-minute hassle."
  },
  {
    "title": "Evening Cultural Programs",
    "description": "In day-night packages, enjoy extra magic shows, puppet performances, and local folk entertainment in the evening hours under open village-style settings."
  },
  {
    "title": "Fresh Maharashtrian Meals",
    "description": "Visitors are treated to authentic local cuisine served on banana leaves—breakfast, unlimited lunch thali, and evening tea/snacks are included in most packages."
  },
  {
    "title": "Safe & Supervised Facilities",
    "description": "The entire park is child-friendly with lifeguards, activity guides, and clearly marked areas—ensuring safety during both water play and land activities."
  },
  {
    "title": "Group Discounts & School Reservations",
    "description": "Special rates and group bookings are available for school picnics. Teachers can reserve batches online and coordinate directly via phone with the park team."
  }
],




"services": [
  {
    "name": "All-Inclusive Day Tour to Morachi Chincholi",
    "description": "A comprehensive day-long experience covering farm tours, animal interactions, cultural programs, and delicious farm-fresh meals, designed to offer a perfect blend of education and recreation for families and groups."
  },
  {
    "name": "Family Tour Package with Meals and Games",
    "description": "Tailored packages for families including nutritious vegetarian meals, supervised outdoor games for all ages, and relaxing farm walks ensuring a fun-filled day with comfort and safety."
  },
  {
    "name": "School/College Group Tour Deals",
    "description": "Specially priced group packages featuring guided farm activities, educational workshops, transport coordination, and customizable schedules to suit school or college curricula and group sizes."
  },
  {
    "name": "Agro-Tourism Experience with Guide",
    "description": "Expert-led agro-tourism tours highlighting traditional farming methods, crop cycles, and ecological conservation practices to deepen visitors' understanding of sustainable agriculture."
  },
  {
    "name": "Adventure + Food Package",
    "description": "Combining adrenaline-pumping activities like nature trails and obstacle courses with wholesome farm-to-table meals for a balanced day of excitement and nourishment."
  },
  {
    "name": "Couple Tour Plan with Activities",
    "description": "Romantic and engaging day plans for couples featuring serene farm walks, pottery or craft workshops, private picnic spots, and shared meals in scenic settings."
  },
  {
    "name": "Farm Stay + Lunch Package",
    "description": "Day-use farm stay options allowing visitors to relax in comfortable farm cottages, enjoy freshly prepared lunches, and engage in evening cultural programs or nature walks."
  },
  {
    "name": "Weekend Package for Groups",
    "description": "Convenient weekend-only deals with coordinated transport, extended activity hours, special group meals, and recreational options tailored for large families, friends, or corporate outings."
  },
  {
    "name": "Cultural and Traditional Tour Combo",
    "description": "Immersive tours featuring folk music, dance performances, storytelling sessions, and craft demonstrations paired with farm experiences to showcase rural Maharashtrian heritage."
  },
  {
    "name": "Tour with Bullock Cart + Bird Watching",
    "description": "A unique combination of rustic bullock cart rides around the farm and guided bird watching excursions highlighting local avian diversity for an enriching nature experience."
  },
  {
    "name": "Eco-Educational Packages",
    "description": "Structured programs with environmental learning modules, sustainability workshops, and nature walks designed especially for students and eco-enthusiasts."
  },
  {
    "name": "One-Day Travel Plan with Itinerary",
    "description": "Fully planned itinerary for one-day trips including pick-up/drop-off, scheduled activities, meal times, rest breaks, and optional add-ons to maximize visitors’ experience."
  },
  {
    "name": "Budget Tour Plan for Students and Families",
    "description": "Affordable tour options that maintain quality experiences while ensuring access for schools, budget-conscious families, and social groups without compromising safety or engagement."
  },
  {
    "name": "Group Discount Packages for Morachi Chincholi",
    "description": "Attractive discounts and priority booking privileges for large groups with flexible arrangements, catering to schools, clubs, corporate teams, and extended families."
  },
  {
    "name": "Hurda Party or Mango Mahotsav Add-Ons",
    "description": "Seasonal festival packages allowing visitors to participate in traditional Hurda parties or Mango festivals, featuring special food items, folk performances, and celebratory activities."
  }
],
"tableData": [
  ["All-Inclusive Day Tour to Morachi Chincholi", "Family Tour Package with Meals and Games"],
  ["School/College Group Tour Deals", "Agro-Tourism Experience with Guide"],
  ["Adventure + Food Package", "Couple Tour Plan with Activities"],
  ["Farm Stay + Lunch Package", "Weekend Package for Groups"],
  ["Cultural and Traditional Tour Combo", "Tour with Bullock Cart + Bird Watching"],
  ["Eco-Educational Packages", "One-Day Travel Plan with Itinerary"],
  ["Budget Tour Plan for Students and Families", "Group Discount Packages for Morachi Chincholi"],
  ["Hurda Party or Mango Mahotsav Add-Ons", ""]
],



"whychoose": [
  {
    "WhyChooseheading": "Easy and Convenient Online Booking",
    "WhyChoosedescription": "Morachi Chincholi Water Park offers a seamless online booking system that allows visitors to reserve their spots from anywhere, ensuring hassle-free planning for school picnics, family outings, or group visits."
  },
  {
    "WhyChooseheading": "Flexible Packages for Day and Night Visits",
    "WhyChoosedescription": "Choose from multiple packages including day-only and day-night combos, designed to fit different group needs and budgets, with clear details on timings, meals, and activities available during each visit."
  },
  {
    "WhyChooseheading": "Comprehensive Activity Options",
    "WhyChoosedescription": "The water park features a wide range of attractions such as rain dance, swimming pool, bullock cart rides, tractor tours, adventure games, and cultural shows, providing fun and engagement for visitors of all ages."
  },
  {
    "WhyChooseheading": "Healthy and Delicious Meal Plans Included",
    "WhyChoosedescription": "All booking packages include thoughtfully prepared meals featuring authentic Maharashtrian cuisine made with fresh, organic ingredients, catering to various dietary preferences and ensuring a satisfying dining experience."
  },
  {
    "WhyChooseheading": "Safety and Supervision for All Visitors",
    "WhyChoosedescription": "Strict safety protocols and trained staff supervision guarantee a secure environment for children and adults alike, especially during water-based activities and adventure games."
  },
  {
    "WhyChooseheading": "Ideal Location Close to Pune",
    "WhyChoosedescription": "Located near Pune, Morachi Chincholi Water Park is easily accessible, making it a perfect destination for school picnics and family day trips without the hassle of long travel times."
  }
]























    }

const faqData = [
  {
    id: 'FAQ1',
    question: 'What are the Morachi Chincholi tour packages available?',
    answer: 'Morachi Chincholi offers Day Package, Day + Night Package, and Residential Package, each including meals, adventure activities, and cultural experiences suitable for all age groups.',
  },
  {
    id: 'FAQ2',
    question: 'What is included in the Day Package?',
    answer: 'The Day Package (9:30 AM – 6:00 PM) includes breakfast, lunch, high tea, swimming pool, rain dance, boating, bullock cart ride, horse riding, adventure games, indoor games, and cultural shows.',
  },
  {
    id: 'FAQ3',
    question: 'What additional benefits does the Day + Night Package offer?',
    answer: 'The Day + Night Package (9:30 AM – 9:00 PM) includes all Day Package activities plus dinner, making it ideal for extended outings and group events.',
  },
  {
    id: 'FAQ4',
    question: 'What does the Residential Package include?',
    answer: 'The Residential Package includes all Day Package amenities along with overnight stay in cottages and local sightseeing, perfect for weekend getaways and team-building events.',
  },
  {
    id: 'FAQ5',
    question: 'What are the charges for these packages?',
    answer: 'Day Package costs ₹600 for adults and ₹300 for children aged 4–10. Day + Night Package is ₹1,400 for adults and ₹700 for children. Residential Package is ₹1,500 per person.',
  },
  {
    id: 'FAQ6',
    question: 'Are the meals vegetarian and hygienic?',
    answer: 'Yes, all meals served in the packages are pure vegetarian, freshly prepared, and follow strict hygiene standards.',
  },
  {
    id: 'FAQ7',
    question: 'What adventure and cultural activities are available?',
    answer: 'Activities include swimming, rain dance, bullock cart and tractor rides, horse riding, boating, cricket, volleyball, badminton, magic shows, and puppet shows.',
  },
  {
    id: 'FAQ8',
    question: 'Is advance booking necessary for Morachi Chincholi tours?',
    answer: 'Yes, advance booking (at least 2–3 weeks ahead) is recommended, especially for school groups and during peak seasons.',
  },
  {
    id: 'FAQ9',
    question: 'What are the contact details for booking and inquiries?',
    answer: 'You can contact the organizers at +91 96891 25047, +91 96237 55047, +91 96731 32497 or email thopatemala@gmail.com for bookings and queries.',
  },
  {
    id: 'FAQ10',
    question: 'Are there facilities like washrooms and rest areas at the venue?',
    answer: 'Yes, the venue is equipped with clean washrooms, shaded seating areas, kids’ play zones, and designated rest spaces for visitors’ comfort.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mrs. Vaishali Apte, Principal, Pune',
    feedback: "Morachi Chincholi offers a perfect mix of rural experience and adventure activities. Our students enjoyed every moment, and the staff was very cooperative.",
    rating: 5,
  },
  {
    id: 2,
    name: 'Mr. Amit Gokhale, School Trip Coordinator, PCMC',
    feedback: "The tour packages at Morachi Chincholi are well organized and cater to different age groups. The food, activities, and hospitality are excellent.",
    rating: 5,
  },
];







































    const carouselItems = testimonials.map(testimonial => (
        <div key={testimonial.name}>
            <blockquote>

                <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
                <footer className=' user'>— {testimonial.name}</footer>
            </blockquote>
        </div>
    ));

    const carouselOptions = {
        loop: true,
        margin: 10,
        nav: true,
        items: 1
    };

    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9689125047",
            "+91 9623755047",
            "+91 9673132497",


        ],
        email: "thopatemala@gmail.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "One Day Picnic Spot Near Pune for Family",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "One Day Trip Near Pune",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Picnic Spot Near Pune ",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Picnic Destination Near Pune ",
        },
        {
            place: "/images/keyword/5.jpg",
            text: " Corporate Outing Resorts Near Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Agri Tourism Near Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Destination Wedding Near Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Hurda Party Places Near Pune",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Water Park Near Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "School Picnic Spots Near Pune for Students",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "One Day Adventure Resorts Near Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Resort Near Pune ",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Forest Resorts Near Pune ",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Nature resorts near pune for weekend",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Mango Mahotsav in Pune",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Krushi Paryatan Kendra near Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Camping Places Near Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Activities Resort Near Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Agro Tourism Near Mumbai for Family",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "One Day Picnic Spot From Mumbai",
        },
        {
            place: "/images/keyword/21.jpg",
            text: "One Day Picnic Packages Near Mumbai",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "School Picnic Spots in Mumbai",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Resort Near Mumbai ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Team Outing Places Near Mumbai",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Corporate Outing Near Mumbai",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Picnic Spot Near Nashik",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Farm House On Rent in Pune ",
        },
    ];


    const images = [
        { src: "/images/gallery/01.jpg", alt: "Image 1" },
        { src: "/images/gallery/02.jpg", alt: "Image 1" },
        { src: "/images/gallery/03.jpg", alt: "Image 1" },
        { src: "/images/gallery/04.jpg", alt: "Image 1" },
        { src: "/images/gallery/05.jpg", alt: "Image 1" },
        { src: "/images/gallery/06.jpg", alt: "Image 1" },
        { src: "/images/gallery/07.jpg", alt: "Image 1" },
        { src: "/images/gallery/08.jpg", alt: "Image 1" },
        { src: "/images/gallery/09.jpg", alt: "Image 1" },
        { src: "/images/gallery/010.jpg", alt: "Image 1" },
        { src: "/images/gallery/011.jpg", alt: "Image 1" },
        { src: "/images/gallery/012.jpg", alt: "Image 1" },

    ];

const morachiTourPackageSchema = {
  "@context": "https://schema.org",
  "@type": "TouristTrip",
  "name": "Morachi Chincholi Tour Package",
  "description": "All-inclusive Morachi Chincholi day tours with family-friendly meals, adventure activities, agro-tourism experiences, cultural events, and guided farm tours. Ideal for school groups, couples, and weekend getaways.",
  "touristType": ["Families", "School Groups", "Couples", "Adventure Seekers"],
  "provider": {
    "@type": "TravelAgency",
    "name": "Anand Krushi Paryatan Kendra",
    "url": "https://morachichincholi.in/"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1200",
    "availability": "https://schema.org/InStock",
    "url": "https://morachichincholi.in/tour-packages"
  },
  "itinerary": [
    "Guided agro-tourism farm experience",
    "Bullock cart rides and bird watching",
    "Traditional cultural shows and folk performances",
    "Adventure activities and games",
    "Farm stay option with local meals",
    "Special add-ons like Hurda Party and Mango Mahotsav"
  ],
  "duration": "PT8H"
};




    return (
        <div>
<Helmet>
  <title>Morachi Chincholi Tour Package | Family, School & Group Day Tours</title>
  <meta 
    name="description" 
    content="Book an all-inclusive Morachi Chincholi tour package featuring farm stays, agro-tourism, adventure activities, cultural experiences, and guided tours. Perfect for families, schools, couples, and groups." 
  />
  <meta 
    name="keywords" 
    content="Morachi Chincholi tour package, Family tour packages Pune, School group tours Morachi Chincholi, Agro-tourism tour package, Adventure and food combos, Weekend tour packages near Pune, Couple tour plan Morachi Chincholi, Farm stay with lunch package, Cultural and traditional tours, Bullock cart rides and bird watching, Eco-educational tour packages, Budget tour packages Pune, Group discounts Morachi Chincholi, Hurda party add-on, Mango Mahotsav tour package" 
  />
  <script type="application/ld+json">
    {JSON.stringify(morachiTourPackageSchema)}
  </script>
</Helmet>
            <section className="breadcrumb-main pb-20 pt-14" style={{ backgroundImage: 'url(images/bg/bg1.jpg)' }}>
                <div className="section-shape section-shape1 top-inherit bottom-0" style={{ backgroundImage: 'url(images/shape8.png)' }}></div>
                <div className="breadcrumb-outer">
                    <div className="container">
                        <div className="breadcrumb-content text-center">
                            <h1 className="mb-3"> {cardData.keyword}</h1>

                        </div>
                    </div>
                </div>
                <div className="dot-overlay"></div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/51.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#609F31', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 darkcolor'> Why Choose Anand Krushi Paryatan Kendra for {cardData.keyword + " Rates"}</h3>
                            {/* <BusRatesTable /> */}

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 darkcolor"> {item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">fAQS {cardData.keyword} For Anand Krushi Paryatan Kendra</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                {faqData.map((faq) => (
                                                    <FAQItemm key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <div>

                                <div className="contact-box Borderr">
                                    <h3 className='darkcolor'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Gallery</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image py-1"

                                            />
                                        </div>
                                    ))}
                                    {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #609F31',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#609F31' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2 text-white"></i>
                                            <div className=''>
                                                <a href="tel:+919689125047" className="d-block  text-white">+91 9689125047</a>
                                                <a href="tel:+919623755047" className="d-block  text-white">+91 9623755047</a>
                                                <a href="tel:+919673132497" className="d-block  text-white">+91 9673132497</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">

                                            <div className='rounded py-2' style={{ backgroundColor: '#609F31' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <i className="bi bi-envelope fs-1 mb-2 text-white"></i>
                                                <a href="mailto:thopatemala@gmail.com" className=" text-white d-block">
                                                    thopatemala@gmail.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">

                                            <div className='rounded py-2' style={{ backgroundColor: '#609F31' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <i className="bi bi-house-fill fs-1 mb-2 text-white"></i>
                                                <p className="whit text-white ">
                                                    <i> Anand Krushi Paryatan Kendra <br />
                                                        Dattatraya Anandrao Thopate, Topate Vasti, Chincholi Morachi, Tal. Shirur, Dist. Pune. Maharashtra - 412218

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Morachichincholitourpackages;